module.exports = __webpack_public_path__ + "static/media/BB_howtoboost_Mobile_SV.605b19ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_howtoboost_Mobile_SV.png
// module id = 713
// module chunks = 0